import {useEffect, useState} from 'react'
import {IReport, StandardReportResponse} from '../types/report.types'

type Response = {
  getReportByIdR: StandardReportResponse
  loading: boolean
}
const useFetchReportById = (id: string) => {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [report, setReport] = useState<IReport>()

  const fetchReportById = async () => {
    try {
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchReportById()
  }, [])

  const response = {
    error,
    loading,
    report,
  }
  return response
}

export default useFetchReportById
